import axios from 'axios';

export interface ICrossSell {
  enableAll: boolean;
  enableClub: boolean;
  device: {
    desktop: boolean;
    mobile: boolean;
  };
  tier: {
    smiles: boolean;
    prata: boolean;
    ouro: boolean;
    diamante: boolean;
  };
}

export const URLS_LAUNCHDARKLY = {
  dev1: 'https://ldrelay.dev1.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJERVYxLU4ifQ%3D%3D',
  dev2: 'https://ldrelay.dev2.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJERVYyLU4ifQ%3D%3D',
  dev3: 'https://ldrelay.dev3.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJERVYzLU4ifQ%3D%3D',
  hml: 'https://ldrelay-hml5.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJITUw1In0%3D',
  blue: 'https://ldrelay-blue.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJCTFVFIn0%3D',
  green: 'https://ldrelay-green.smiles.com.br/sdk/evalx/5ff64893991a4c0aa4974fc7/users/eyJrZXkiOiJHUkVFTiJ9',
  checkEnv: 'https://www.smiles.com.br/mfe-apps/check-env.txt',
};

export class GetLaunchdarkly {
  static async execute() {
    const env = window.smlsEnv;

    try {
      const url = await this.getEnvUrl(env);

      const { data } = await axios.get(url);
      const crossSellConfig = data['api-data'].value.constants.WEB['cross-sell'];

      return { url, ...crossSellConfig };
    } catch (error) {
      console.error('Erro ao obter a configuração cross-sell:', error);
      return null;
    }
  }

  private static async getEnvUrl(env: string) {
    if (env.includes('prd')) {
      try {
        const { data } = await axios.get(URLS_LAUNCHDARKLY.checkEnv);

        return data === 'blue' ? URLS_LAUNCHDARKLY.blue : URLS_LAUNCHDARKLY.green;
      } catch (error) {
        console.error('Erro ao obter o ambiente de produção:', error);
        throw new Error('Não foi possível determinar o ambiente de produção');
      }
    }

    if (env.includes('dev1')) return URLS_LAUNCHDARKLY.dev1;
    if (env.includes('dev2')) return URLS_LAUNCHDARKLY.dev2;
    if (env.includes('dev3')) return URLS_LAUNCHDARKLY.dev3;
    return URLS_LAUNCHDARKLY.hml;
  }
}
